import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

function recentlyViewedProducts() {
  // Keep track of recently viewed products
  let limit = 4;
  let container = document.querySelector('.recently-viewed');
  let productHandle = container.dataset.productHandle;
  let $slideContainer = document.querySelector('.recently-viewed__container');
  let storage = localStorage.getItem('recentlyViewedProducts') || '[]';
  let recentProducts = JSON.parse(storage);
  let productIndex = recentProducts.indexOf(productHandle);
  let inArray = productIndex > -1;
  const sectionWrapper = document.querySelector('#recently-viewed-tab');

  // Check if current item is in the array, and move it to the front
  if (inArray) {
    recentProducts.splice(productIndex, 1);
  }

  // Add current product to the start of the array
  recentProducts.unshift(productHandle);

  // Cut the array down so we dont store a humungous amount of data
  recentProducts = recentProducts.splice(0, limit * 2);

  localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentProducts));

  // Start at 1 so we dont print the current product
  let index = 1;
  let markup = '';

  // Make the ajax request or prints out markup on completion
  function getNextProduct() {
    // Have we hit the limit?
    if (recentProducts[index] && index <= limit) {
      const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
      const url = rootUrl + '/products/' + recentProducts[index] + '?view=recently-viewed';

      axios.get(url).then(json => {
        markup += json.data;
        index++;
        getNextProduct();
      });
    } else {
      $slideContainer.innerHTML = markup;
      var slider = new Flickity('.recently-viewed__slider', {
        // options
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
      });
    }
  }

  // Check we got some products to show
  if (recentProducts.length > index) {
    getNextProduct();
    sectionWrapper.classList.remove('hide');
  } else {
    sectionWrapper.classList.add('hide');
  }
}

export default recentlyViewedProducts;
